import React from 'react';
import './style.css';
import { WorldMap, CountryContext } from "@utils/svg-worldmap";

type VariantPharma3 = {
  id?: string;
  ridx: number;
  cells: Array<{
    cid: string;
  }>;
  data: Array<{
    country: string;
    value: string;
  }>;
};

let deviceSize = null;
let countries = [];
/*typeof window !== 'undefined' && 
       window.innerWidth <= 500 ? 
       deviceSize = 330 : 
       deviceSize = "xxl"; 
const maxMapWidth = 1200;
deviceSize = window !== undefined ? Math.round(window.innerWidth * 0.9) : maxMapWidth;
if (deviceSize >= maxMapWidth) deviceSize = Math.round(maxMapWidth * 0.9);*/
const stylingFunction = ({
  countryValue,
}: CountryContext) => {
  const country = countries.find((c) => c.value === countryValue);
  const colorName = country?.color || "#CCC";

  return {
    fill: colorName,
    stroke: "white",
    strokeWidth: 1.3,
    strokeOpacity: 0.2,
    cursor: "pointer",
  };
};

const getLocalizedText = (context: CountryContext) => {
  let {
    countryName,
    prefix,
    countryValue,
  } = context;
  const country = countries.find((c) => c.value === countryValue);
  countryName = country?._xnamexx || countryName;
  countryValue = country?._value || countryValue;
  return `Country: ${countryName}              
  ${prefix}${countryValue}
  `;
}

const VariantPharma3 = ({ data }: VariantPharma3Props): JSX.Element => {
  countries = data;
  return (
    <div className='interactive-map-container'>
      <div className='variant-pharma-3-interactive-map'>
        <WorldMap
          valuePrefix="Score: "
          data={data.map((country) => {
            country._value = country.value;
            country.value = country.country;// this will be shown in tooltip to replace country name
            return country;
          })}
          richInteraction
          styleFunction={stylingFunction}
          tooltipTextFunction={getLocalizedText}
        />
      </div>
      <div className='variant-pharma-3-interactive-map mb-24 table-desktop floating-table hidden'>
        <table>
          <thead>
            <tr>
              <th>Country</th>
              <th>Score</th>
            </tr>
          </thead>
          <tbody>
            {data.filter(country => country.sidetable == true).map((country, idx) => (
              <tr key={idx}>
                <td>{country._xnamexx}</td>
                <td>{country._value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className='variant-pharma-3-interactive-map mb-6 table-mobile'>
        <table>
          <thead>
            <tr>
              <th>Country</th>
              <th>Score</th>
            </tr>
          </thead>
          <tbody>
            {data.map((country, idx) => (
              <tr key={idx}>
                <td>{country._xnamexx}</td>
                <td>{country._value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
};

export default VariantPharma3;
